import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { AvatarModule } from 'ngx-avatar';
import { CommentsCustomComponent } from './comments-custom.component';
@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    AvatarModule
  ],
  declarations: [
    CommentsCustomComponent
  ],
  exports: [
    CommentsCustomComponent // <-- this!
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ]
})
export class CommentsCustomModule { }